function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import PhoneNumberModal from "./PhoneNumberModal";
import Button from "../../../Misc/Buttons/DefaultBlueButton";

var RecordMobile = function (_React$Component) {
  _inherits(RecordMobile, _React$Component);

  function RecordMobile() {
    var _temp, _this, _ret;

    _classCallCheck(this, RecordMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      modalActive: false
    }, _this.toggleModal = function () {
      return _this.setState({
        modalActive: !_this.state.modalActive
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RecordMobile.prototype.render = function render() {
    var _props = this.props,
        mobileRecordSettings = _props.mobileRecordSettings,
        qrCodeData = _props.qrCodeData;
    var modalActive = this.state.modalActive;
    return React.createElement(React.Fragment, null, React.createElement(PhoneNumberModal, {
      active: modalActive,
      mobileRecordSettings: mobileRecordSettings,
      qrCodeData: qrCodeData,
      onClose: this.toggleModal
    }), React.createElement("div", {
      className: "recorder__toolbar-option recorder__toolbar-option--mobile"
    }, React.createElement("button", {
      className: "button button--style-default button--size-s button--color-lynch recorder__toolbar-link",
      onClick: this.toggleModal
    }, "Record on your mobile phone")), React.createElement(Button, {
      onClick: this.toggleModal,
      className: "small-screen-mobile-record-launcher"
    }, "Record on your mobile phone"));
  };

  return RecordMobile;
}(React.Component);

RecordMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  mobileRecordSettings: PropTypes.object.isRequired,
  qrCodeData: PropTypes.func
} : {};
export default RecordMobile;